import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import {
  useCollapseTableFields,
  useTableLocation,
} from "../../../../utils/helpers/dynamicTableField";
import { CollapseTableBodyComp } from "./collapse-table-body";
import { CollapseTableHeadComp } from "./collapse-table-head";

export const CollapseTable = ({
  index,
  openStates,
  data,
}: {
  index: number;
  openStates: any[];
  data: any;
}) => {
  const dynamicFields = useCollapseTableFields(useTableLocation());
  return (
    <TableRow>
      <TableCell
        style={{ paddingBottom: 0, paddingTop: 0, border: "none" }}
        colSpan={12}
      >
        <Collapse in={openStates[index]} timeout="auto" unmountOnExit>
          <Box
            sx={{
              py: 2,
              px: 4,
              mb: 2,
              background: "rgba(0, 242, 255, 0.02)",
              borderLeft: "2px solid #00f2ff",
              boxShadow: "-10px 0 20px -10px rgba(0, 242, 255, 0.2)",
            }}
          >
            {dynamicFields.map((field: any, idx: number) => (
              <Box key={field.title} sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  sx={{
                    fontFamily: "'Orbitron', sans-serif",
                    color: "#ff9d00",
                    fontSize: "0.9rem",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                  }}
                >
                  {field.title}
                </Typography>
                <Table size="small" aria-label="details">
                  <CollapseTableHeadComp index={idx} />
                  <CollapseTableBodyComp data={data} index={idx} />
                </Table>
              </Box>
            ))}
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
